
import pricingQuery from "@/apollo/queries/pages/pricing.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';
import seoMixin from "@/mixins/seoMixin";

export default {
  name: 'pricing',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin, seoMixin],
  data() {
    return {
      pricing: null,
      plans: null,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responsePricing = await app.apolloProvider.defaultClient.query({
      query: pricingQuery,
      variables: {
        locale: app.i18n?.locale  || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const pricing = responsePricing.data?.pricing;

    try {
      // Make a request to the REST API
      const restApiResponse = await app.$axios.$get('/v1/api/payment-plans/');

      return {
        pricing,
        previewMode,
        plans: restApiResponse, // This is your REST API data
      };
    } catch (err) {
      console.error('REST API request error:', err);
    }
  },
  methods: {
    getPageData() {
      return this.plans?.data;
    },
  },
}
